import { Component, OnInit } from '@angular/core';
import { NgForm} from '@angular/forms';
import { NULL_EXPR } from '@angular/compiler/src/output/output_ast';
import { ActivatedRoute, Router } from '@angular/router';
//import { AdataService } from '../../shared/adata.service';
import { DatePipe } from '@angular/common';
import { UserService } from '../../shared/user.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-transaction-report',
  templateUrl: './transaction-report.component.html',
  styleUrls: ['./transaction-report.component.css']
})
export class TransactionReportComponent implements OnInit {


  public show:boolean = false;
  public mybutton:any = 'Show';
 
  commonUrl : string 

  branchdata:any;
  branchopt:any[];
  b:any={};
  actydata: any;
  actopt: any;
  custopt:any;
  ac:any={};
  accheaddata:any;
  accheadopt:any;
  accsubopt:any;
  ah:any={};
  ag:any={};
  yrfddata: any;
  yrfdopt: any;
  AgentsList : any = [];
  data : any = {};
  a:any={};
  p : any = {};
  formd:any={};
  today = new Date();  

  fldopdtion1:boolean=false;
  fldopdtion2:boolean=false;
  fldopdtion3:boolean=false;
  fldopdtion4:boolean=false;
  fldopdtion5:boolean=false;
  fldopdtion6:boolean=false;
  fldopdtion7:boolean=false;
  fldopdtion8:boolean=false;
  fldopdtion9:boolean=false;
  fldopdtion10:boolean=false;
  fldopdtion11:boolean=false;
  fldopdtion12:boolean=false;
  fldopdtion13:boolean=false;
  transdata: any;
  custdata: any;
  DateValues:string;
  userName : any;
  logbranch:any;
  sheetdata: any;
  accno: string;
  notaccno: string;
  disaccdata: any;
  disacopt: any;
  display: string;
  pigmydata: any;
  pigopt: any;
  transopt: any;
  fldopdtion14: boolean;
  fldopdtion15: boolean;
  

  constructor( private service : UserService,private router: Router,private route: ActivatedRoute,private datePipe:DatePipe) 
  {
    this.commonUrl = service.rootUrl;
    this.userName = localStorage.getItem('userName');
    this.logbranch= parseInt(localStorage.getItem('BRANCH_ID'));
  }

  ngOnInit() {

    this.loadbranch();
    this.actype();
    // this.acchead();
    this.GetAgentData();
    debugger;
    this.formd.BRANCH_ID=this.logbranch
    this.yearset(this.logbranch);
    this.formd.actype=3;
    if(this.formd.actype==3)
    {
      this.acscheme(this.formd.actype);
    }
     this.fldopdtion1=false;
     this.fldopdtion2=false;
     this.fldopdtion3=false;
     this.fldopdtion4=false;
     this.fldopdtion5=false;
     this.fldopdtion6=false;
     this.fldopdtion7=false;
     this.fldopdtion8=false;
     this.fldopdtion9=false;
     this.fldopdtion10=false;
     this.fldopdtion11=false;
     this.fldopdtion12=false;
     this.fldopdtion13=false;
     this.fldopdtion14=false;
     this.fldopdtion15=false;
    
     this.formd.fromdate=this.getdatefun('01-01-2000');
     this.formd.todate=this.getdatefun(this.today);
  }

  loadbranch()
  {
    
    this.branchdata=this.service.getbranch1();
    this.branchdata.subscribe(
      (response:any)=>{
        this.branchopt=response.BranchModels;
        console.log("Branch");
        console.log(this.branchopt);
        });
        
    }
    

    actype()
    {
      this.actydata=this.service.gettrans();
      this.actydata.subscribe(
        (actyres:any)=>{
          this.actopt=actyres;
          console.log(this.actopt);
        }
      )
    }
    

    yearset(Branch:number)
    {
      debugger;
      this.yrfddata=this.service.Yearseting1(Branch);
      this.yrfddata.subscribe(
        (yrfdres:any)=>
        {
          this.yrfdopt=Array.of(yrfdres);
        }
      )
    }


    acscheme(module:number)
     {
       debugger;
       this.accheaddata=this.service.ledgerlistget(module);
       this.accheaddata.subscribe(
         (schres:any)=>{
         this.accheadopt=schres;
         console.log(this.accheadopt);
       }
       )
    }
    
    subscheme(modid:number,glsubid:number)
     {

       debugger;
       this.accheaddata=this.service.ledgersublistget(modid,glsubid);
       this.accheaddata.subscribe(
         (schres:any)=>{
         this.accsubopt=schres;
         console.log(this.accsubopt);
       }
       )
    }
  
    GetAgentData(){
      debugger;
    this.data = this.service.GetAllAgents();
    this.data.subscribe(
         (response: any) => {         
          this.AgentsList= response;        
  }
  ) 
}

    toggle() {
     
      this.show = !this.show;
   
      // CHANGE THE NAME OF THE BUTTON.
      if(this.show){  
        this.mybutton= "Hide";
        
      } else {
        this.mybutton= "Show";
       }    
    }

    // viewreport(BRANCH_ID:number,actype:string,GLSUB_ID:number,GLSUB_ID1:number,cr_dr:number,transmode:number,fromdate:any,todate:any)
    // {
    //   debugger;
    //     this.transdata=this.service.transreport(BRANCH_ID,actype,GLSUB_ID,GLSUB_ID1,cr_dr,transmode,fromdate,todate);
    //     this.transdata.subscribe(
    //       (restrans:any)=>
    //       {
    //           console.log(restrans);
    //       }
    //     )
    // }

    //transactionreport(formrpt:NgForm,frmdt:any)
    transactionreport(curryear:number,basicreport:boolean,detailreport:boolean,stmtreport:boolean,dailycolreport:boolean,loanrecreport:boolean,detailreport2:boolean,pigmysheetreport:boolean,loanondeposit:boolean,BRANCH_ID:number,actype:number,L_Code:number,GLSUB_ID:number,cr_dr:number,transmode:number,AGENT_ID:number,acbranch:string,yrnd:string,ac_no:string,glsub:string,Name:string,fromdate:Date,todate:Date,chkledger:boolean,pigmysheet:string,pigmycollection:string,pigmyreport1 :string,remdt:boolean,accountwisereport:boolean,formd:NgForm)
    {
      //formrpt.frmdt);
      debugger;
      if(cr_dr==undefined||null)
      cr_dr=0;

      debugger;
      this.accno = acbranch+yrnd+ac_no+glsub;   
     
      //console.log(formrpt);
      document.getElementById('loader-spinner').style.display = "block";
      
      this.transdata=this.service.reporttransaction1(this.chckbint(curryear),this.chckbbol(basicreport),this.chckbbol(detailreport),this.chckbbol(stmtreport),this.chckbbol(dailycolreport),this.chckbbol(loanrecreport), this.chckbbol(detailreport2),this.chckbbol(pigmysheetreport),this.chckbbol(loanondeposit),this.chckbint(BRANCH_ID), this.chckbint(actype),this.chckbint(L_Code),this.chckbint(GLSUB_ID),this.chckbint(cr_dr),this.chckbint(transmode),this.chckbint(AGENT_ID),this.chckbstr(acbranch),this.chckbstr(yrnd),this.chckbstr(ac_no),this.chckbstr(glsub),this.chckbstr(Name),this.chckdt(fromdate),this.chckdt(todate),this.chckbbol(chkledger),this.chckbstr(pigmysheet),this.chckbstr(pigmycollection),this.chckbstr(pigmyreport1),this.chckbbol(remdt),this.chckbbol( accountwisereport));
         this.transdata.subscribe(
           (restrans:any)=>
        {
          document.getElementById('loader-spinner').style.display = "none";
          this.callreport1(this.chckbbol(basicreport),this.chckbbol(detailreport),this.chckbbol(stmtreport),this.chckbbol(dailycolreport),this.chckbbol(loanrecreport),this.chckbbol(detailreport2),this.chckbbol(pigmysheetreport),this.chckbbol(loanondeposit),this.chckbstr(pigmysheet),this.chckbstr(pigmycollection),this.chckbstr(pigmyreport1),this.chckbstr(this.accno)); 
                 
            // this.callreport(this.chckbbol(basicreport),this.chckbbol(detailreport),this.chckbbol(stmtreport),this.chckbbol(dailycolreport),this.chckbbol(loanrecreport),this.chckbbol(detailreport2),this.chckbbol(pigmysheetreport),this.chckbbol(loanondeposit));   
             this.resetForm(formd);
          }
         )
      
    }
                                            
    transactionreport1(curryear:number,basicreport:boolean,detailreport:boolean,stmtreport:boolean,dailycolreport:boolean,loanrecreport:boolean,detailreport2:boolean,pigmysheetreport:boolean,loanondeposit:boolean,BRANCH_ID:number,actype:number,L_Code:number,GLSUB_ID:number,cr_dr:number,transmode:number,AGENT_ID:number,acbranch:string,yrnd:string,ac_no:string,glsub:string,Name:string,fromdate:Date,todate:Date, chkledger:boolean,pigmysheet:string,pigmycollection:string,pigmyreport1 :string,remdt:boolean,accountwisereport:boolean,formd:NgForm)//formd.todate,formd.pigmycollection,formd.pigmyreport1,formd.pigmysheet
    {

      //formrpt.frmdt);
      debugger;
      if(cr_dr==undefined||null)
          cr_dr=0;
       debugger;
          this.accno = acbranch+yrnd+ac_no+glsub; 
  

       //if(pigmysheet=="pigmyrpt")
     //{
      //   this.sheetreport(curryear, dailycolreport, BRANCH_ID,actype,L_Code,GLSUB_ID,cr_dr,transmode,AGENT_ID,acbranch,yrnd,ac_no:string,glsub:string,Name,fromdate,todate,pigmysheet,pigmycollection,pigmyreport1 ,remdt )
      // }
      // else
      // {
      //console.log(formrpt);
      document.getElementById('loader-spinner').style.display = "block";
      this.transdata=this.service.reporttransaction1(this.chckbint(curryear),this.chckbbol(basicreport),this.chckbbol(detailreport),this.chckbbol(stmtreport),this.chckbbol(dailycolreport),this.chckbbol(loanrecreport), this.chckbbol(detailreport2),this.chckbbol(pigmysheetreport),this.chckbbol(loanondeposit),this.chckbint(BRANCH_ID), this.chckbint(actype),this.chckbint(L_Code),this.chckbint(GLSUB_ID),this.chckbint(cr_dr),this.chckbint(transmode),this.chckbint(AGENT_ID),this.chckbstr(acbranch),this.chckbstr(yrnd),this.chckbstr(ac_no),this.chckbstr(glsub),this.chckbstr(Name),this.chckdt(fromdate),this.chckdt(todate),this.chckbbol(chkledger),this.chckbstr(pigmysheet),this.chckbstr(pigmycollection),this.chckbstr(pigmyreport1),this.chckbbol(remdt),this.chckbbol( accountwisereport));
     // reporttransaction1(this.chckbbol(Eng),this.chckbbol(kan),this.chckbbol(basicreport),this.chckbbol(detailreport),this.chckbbol(stmtreport),this.chckbbol(dailycolreport),this.chckbint(BRANCH_ID),this.chckbint(actype),this.chckbint(L_Code),this.chckbint(GLSUB_ID),this.chckbint(cr_dr),this.chckbint(transmode),this.chckbint(AGENT_ID),this.chckbstr(acbranch),this.chckbstr(yrnd),this.chckbstr(ac_no),this.chckbstr(glsub),this.chckbstr(Name),this.chckdt(fromdate),this.chckdt(todate),this.chckbbol(pigmycollection),this.chckbbol(pigmysheet),this.chckbstr(pigmyreport1));
         this.transdata.subscribe(
           (restrans:any)=>
        {
          document.getElementById('loader-spinner').style.display = "none";
             this.callreport1(this.chckbbol(basicreport),this.chckbbol(detailreport),this.chckbbol(stmtreport),this.chckbbol(dailycolreport),this.chckbbol(loanrecreport),this.chckbbol(detailreport2),this.chckbbol(pigmysheetreport),this.chckbbol(loanondeposit),this.chckbstr(pigmysheet),this.chckbstr(pigmycollection),this.chckbstr(pigmyreport1),this.chckbstr(this.accno));   
             this.resetForm(formd);
        }
         )
        
    }

    // sheetreport(curryear:Number, dailycolreport:Boolean, BRANCH_ID:number,actype:number,L_Code:number,GLSUB_ID:number,cr_dr:number,transmode:number,AGENT_ID:number,acbranch:string,yrnd:string,ac_no:string,glsub:string,Name:string,fromdate:Date,todate:Date,pigmysheet:string,pigmycollection:string,pigmyreport1 :string,remdt:string )
    // {
    //   this.sheetdata=this.service.sheetreporttransaction( );
    //   this.sheetdata.subscribe(
    //     (sheetresponse:any)=>
    //     {

    //     }
    //   )
    // }
   

    callreport1(basicreport:boolean,detailreport:boolean,stmtreport:boolean,dailycolreport:boolean,loanrecreport:boolean,detailreport2:boolean,pigmysheetreport:boolean,loanondeposit:boolean,pigmysheet:string,pigmycollection:string,pigmyreport1:string,accno:string)
    {
      debugger;
      if(basicreport==true)
      {
          this.TransBasic();
      }
      if(detailreport==true)
      {
        this.TranDetails();
      }
      if(stmtreport==true)
      {
        debugger;
          this.TransStmt();
      }
      if(dailycolreport==true ||pigmysheetreport==true)
      {
        debugger;
        if(pigmycollection=="collecrpt")
        {
          debugger;
          this.TransDailcol()
        }
       else if (pigmysheet=="pigmysheet")
         {
          if(pigmyreport1=="0")
         {
           debugger;
            this.Transmonthly();
         }
         else if(pigmyreport1=="1")
          {
            debugger;
               this.transfivr();
          }
         if(loanrecreport==true)
      {
          this.loanrecovery();
      }
      if(detailreport2==true)
      {
          this.detailrport2();
      }
      if(pigmysheetreport==true)
      {
          this.Transmonthly();
      }
      
     
      if(loanondeposit==true)
      {
          this. TransLoandeposit();
      }
       //  else if(pigmyreport1=="3")
        // {

         //}
         

        }
      
      }
      if (pigmysheet=="pigmyrpt")
         {
          if(pigmyreport1=="0")
         {
           debugger;
            this.Transmonthly();
         }
         else if(pigmyreport1=="1")
          {
            debugger;
               this.transfivr();
          }
         }
    }


    callreport(basicreport:boolean,detailreport:boolean,stmtreport:boolean,dailycolreport:boolean,loanrecreport:boolean,detailreport2:boolean,pigmysheetreport:boolean,loanondeposit:boolean,accno:string)
    {
      debugger;
      if(basicreport==true)
      {
          this.TransBasic();
      }
      if(detailreport==true)
      {
        this.TranDetails();
      }
      if(stmtreport==true)
      {
          this.TransStmt();
      }
      if(dailycolreport==true)
      {
          this.TransDailcol();
      }
      if(pigmysheetreport==true)
      {
          this.Transmonthly();
      }
      if(loanrecreport==true)
      {
          this.loanrecovery();
      }
      if(detailreport2==true)
      {
          this.detailrport2();
      }
     
     
      if(loanondeposit==true)
      {
          this. TransLoandeposit();
      }

    }

 chckbbol(arg:boolean)
 {
   if (arg!=null)
   {
     return true;
   }
   else
     return false;
 }
 
 chckbint(arg:number)
 {
   if (arg!=null)
   {
     return arg;
   }
   else
     return 0;
 }
  
 chckbstr(arg:string)
 {
   if (arg!=null)
   {
     return arg;
   }
   else
     return "0";
 }

 chckdt(arg:Date)
 {
   if (arg!=null)
   {
     return arg;
   }
 }
    
 TranDetails(){
  let cr_dr="0";
  if(this.formd.cr_dr==undefined||null)
  cr_dr="0";
  else
  cr_dr=this.formd.cr_dr;
  window.open(this.commonUrl+'/Reports/transDaetails/transdetails.aspx?userName='+this.userName+'&fromdate='+this.formd.fromdate+'&todate='+this.formd.todate+'&cr_dr='+this.formd.cr_dr+'&actype='+this.formd.actype+'&transmode='+this.formd.transmode+'&BRANCH_ID='+this.formd.BRANCH_ID+'&chkledger='+this.formd.chkledger);
 }

 TransBasic()
 {
   debugger;
   let cr_dr="0";
   if(this.formd.cr_dr==undefined)
   cr_dr="0";
   else
   cr_dr=this.formd.cr_dr;

  window.open(this.commonUrl+'/Reports/Transaction_report/tarnsBasic2.aspx?userName='+this.userName+'&fromdate='+this.formd.fromdate+'&todate='+this.formd.todate+'&cr_dr='+this.formd.cr_dr+'&actype='+this.formd.actype+'&transmode='+this.formd.transmode+'&BRANCH_ID='+this.formd.BRANCH_ID+'&chkledger='+this.formd.chkledger);
 }
 TransStmt()
 {
  debugger;
 
  window.open(this.commonUrl+'/Reports/AccountStat/AccountStatement.aspx?userName='+this.userName+'&MODID='+this.formd.actype+'&BRANCH_ID='+this.formd.BRANCH_ID+'&fromdate='+this.formd.fromdate+'&todate='+this.formd.todate+'&accno='+this.accno);
 }
 TransDailcol()
 {
   debugger;
  window.open(this.commonUrl+'/Reports/DailyCollection/Daily_Collection.aspx?userName='+this.userName+'&branchid='+this.logbranch+'&fromdate='+this.formd.fromdate+'&todate='+this.formd.todate);
 }

//  Transmonthly()
//  {
 // window.open(this.commonUrl+'/Reports/PigmyMonthly/PigmyMonthly.aspx?userName='+this.userName);
 //}
 transfivr()
 {
  window.open(this.commonUrl+'/Reports/PigmyMonthly/PigmyMonthly.aspx?userName='+this.userName+'&fromdate='+this.formd.fromdate+'&todate='+this.formd.todate+'&BRANCH_ID='+this.formd.BRANCH_ID);
 }
 loanrecovery()
 {
  window.open(this.commonUrl+'/Reports/LoanRecovery/LoanRecovery.aspx?userName='+this.userName);
 }
 detailrport2()
 {
  window.open(this.commonUrl+'/Reports/transDetails2rpt/TransDetails2.aspx?userName='+this.userName);
 }
 Transmonthly()
 {
   debugger;
  window.open(this.commonUrl+'/Reports/PigmyMonthly2/PigmyMonthly1.aspx?userName='+this.userName+'&fromdate='+this.formd.fromdate+'&todate='+this.formd.todate+'&BRANCH_ID='+this.formd.BRANCH_ID);
 }
 
 TransLoandeposit()
 {
  window.open(this.commonUrl+'/Reports/PigmyMonthly2/PigmyMonthly1.aspx?userName='+this.userName+'&fromdate='+this.formd.fromdate+'&todate='+this.formd.todate+'&BRANCH_ID='+this.formd.BRANCH_ID);
 }

 
 basic()
 {
  this.fldopdtion1=true;
  this.fldopdtion2=true;
  this.fldopdtion3=true;
  this.fldopdtion4=true;
  this.fldopdtion5=true;
  this.fldopdtion6=true;
  this.fldopdtion7=false;
  this.fldopdtion8=false;
  this.fldopdtion9=false;
  this.fldopdtion10=true;
  this.fldopdtion11=true;
  this.fldopdtion12=false;
  this.fldopdtion13=false;
  this.fldopdtion14=false;
  this.fldopdtion15=false;
  this.formd.detailreport=null;
  this.formd.stmtreport=null;
  this.formd.dailycolreport=null;
  this.formd.loanrecreport=null;
  this.formd.detailreport2=null;
  this.formd.pigmysheetreport=null;
  this.formd.loanondeposit=null;
 }

 detail()
 {
  this.fldopdtion1=true;
  this.fldopdtion2=true;
  this.fldopdtion3=true;
  this.fldopdtion4=true;
  this.fldopdtion5=true;
  this.fldopdtion6=true;
  this.fldopdtion7=false;
  this.fldopdtion8=false;
  this.fldopdtion9=false;
  this.fldopdtion10=true;
  this.fldopdtion11=true;
  this.fldopdtion12=false;
  this.fldopdtion13=false;
  this.fldopdtion14=false;
  this.fldopdtion15=false;
  this.formd.basicreport=null;
  this.formd.stmtreport=null;
  this.formd.dailycolreport=null;
  this.formd.loanrecreport=null;
  this.formd.detailreport2=null;
  this.formd.pigmysheetreport=null;
   this.formd.loanondeposit=null;
 }

 statement()
 {
  this.fldopdtion1=true;
  this.fldopdtion2=true;
  this.fldopdtion3=true;
  this.fldopdtion4=true;
  this.fldopdtion5=false;
  this.fldopdtion6=false;
  this.fldopdtion7=false;
  this.fldopdtion8=true;
  this.fldopdtion9=true;
  this.fldopdtion10=true;
  this.fldopdtion11=true;
  this.fldopdtion12=false;
  this.fldopdtion13=false;
  this.fldopdtion14=false;
  this.fldopdtion15=false;
  this.formd.basicreport=null;
  this.formd.detailreport=null;
  this.formd.dailycolreport=null;
  this.formd.loanrecreport=null;
  this.formd.detailreport2=null;
  this.formd.pigmysheetreport=null;
   this.formd.loanondeposit=null;
 }

 dailycoll()
 {
  this.fldopdtion1=true;
  this.fldopdtion2=true;
  this.fldopdtion3=true;
  this.fldopdtion4=true;
  this.fldopdtion5=false;
  this.fldopdtion6=false;
  this.fldopdtion7=true;
  this.fldopdtion8=false;
  this.fldopdtion9=false;
  this.fldopdtion10=true;
  this.fldopdtion11=false;
  this.fldopdtion12=true;
  this.fldopdtion13=true;
  this.fldopdtion14=false;
  this.fldopdtion15=false;
  this.formd.basicreport=null;
  this.formd.detailreport=null;
  this.formd.stmtreport=null;
  this.formd.loanrecreport=null;
  this.formd.detailreport2=null;
  this.formd.pigmysheetreport=null;
   this.formd.loanondeposit=null;
 }

 loanreco()
 {
  this.fldopdtion1=true;
  this.fldopdtion2=true;
  this.fldopdtion3=true;
  this.fldopdtion4=true;
  this.fldopdtion5=false;
  this.fldopdtion6=false;
  this.fldopdtion7=false;
  this.fldopdtion8=false;
  this.fldopdtion9=false;
  this.fldopdtion10=true;
  this.fldopdtion11=true;
  this.fldopdtion12=false;
  this.fldopdtion13=false;
  this.fldopdtion14=false;
  this.fldopdtion15=false;
  this.formd.basicreport=null;
  this.formd.detailreport=null;
  this.formd.dailycolreport=null;
  this.formd.stmtreport=null;
   this.formd.detailreport2=null;
  this.formd.pigmysheetreport=null;
   this.formd.loanondeposit=null;
 }
 detail2()
 {
  this.fldopdtion1=true;
  this.fldopdtion2=true;
  this.fldopdtion3=true;
  this.fldopdtion4=true;
  this.fldopdtion5=true;
  this.fldopdtion6=false;
  this.fldopdtion7=false;
  this.fldopdtion8=false;
  this.fldopdtion9=false;
  this.fldopdtion10=true;
  this.fldopdtion11=true;
  this.fldopdtion12=false;
  this.fldopdtion13=false;
  this.fldopdtion14=false;
  this.fldopdtion15=false;
  this.formd.basicreport=null;
  this.formd.detailreport=null;
  this.formd.dailycolreport=null;
  this.formd.stmtreport=null;
  this.formd.loanrecreport=null;
   this.formd.pigmysheetreport=null;
   this.formd.loanondeposit=null;
 }
 sheetreport()
 {
  this.fldopdtion1=true;
  this.fldopdtion2=true;
  this.fldopdtion3=true;
  this.fldopdtion4=true;
  this.fldopdtion5=false;
  this.fldopdtion6=false;
  this.fldopdtion7=false;
  this.fldopdtion8=false;
  this.fldopdtion9=false;
  this.fldopdtion10=true;
  this.fldopdtion11=true;
  this.fldopdtion12=false;
  this.fldopdtion13=true;
  this.fldopdtion14=false;
  this.fldopdtion15=false;
  this.formd.basicreport=null;
  this.formd.detailreport=null;
  this.formd.dailycolreport=null;
  this.formd.stmtreport=null;
  this.formd.loanrecreport=null;
  this.formd.detailreport2=null;
    this.formd.loanondeposit=null;
 }

 dailycollReport()
 {
  this.fldopdtion1=true;
  this.fldopdtion2=true;
  this.fldopdtion3=true;
  this.fldopdtion4=true;
  this.fldopdtion5=false;
  this.fldopdtion6=false;
  this.fldopdtion7=false;
  this.fldopdtion8=true;
  this.fldopdtion9=true;
  this.fldopdtion10=true;
  this.fldopdtion11=false;
  this.fldopdtion12=false;
  this.fldopdtion13=true;
  this.fldopdtion14=false;
  this.fldopdtion15=false;
  this.formd.basicreport=null;
  this.formd.detailreport=null;
  this.formd.dailycolreport=null;
  this.formd.stmtreport=null;
  this.formd.loanrecreport=null;
  this.formd.detailreport2=null;
  this.formd.loanondeposit=null;
 }
 accountwisereport()
 {
  this.fldopdtion1=true;
  this.fldopdtion2=true;
  this.fldopdtion3=true;
  this.fldopdtion4=true;
  this.fldopdtion5=false;
  this.fldopdtion6=false;
  this.fldopdtion7=false;
  this.fldopdtion8=true;
  this.fldopdtion9=true;
  this.fldopdtion10=true;
  this.fldopdtion11=false;
  this.fldopdtion12=true;
  this.fldopdtion13=true;
  this.fldopdtion14=false;
  this.fldopdtion15=false;
  this.formd.basicreport=null;
  this.formd.stmtreport=null;
  this.formd.dailycolreport=true;
  this.formd.loanrecreport=null;
  this.formd.detailreport2=null;
  this.formd.pigmysheetreport=null;
   this.formd.loanondeposit=null;
 }





 loandeposit()
 {
  this.fldopdtion1=true;
  this.fldopdtion2=true;
  this.fldopdtion3=true;
  this.fldopdtion4=true;
  this.fldopdtion5=false;
  this.fldopdtion6=false;
  this.fldopdtion7=false;
  this.fldopdtion8=false;
  this.fldopdtion9=false;
  this.fldopdtion10=true;
  this.fldopdtion11=true;
  this.fldopdtion12=false;
  this.fldopdtion13=false;
  this.fldopdtion14=false;
  this.fldopdtion15=false;
  this.formd.basicreport=null;
  this.formd.detailreport=null;
  this.formd.dailycolreport=null;
  this.formd.stmtreport=null;
  this.formd.loanrecreport=null;
  this.formd.detailreport2=null;
  this.formd.pigmysheetreport=null;
  
 }
 setbranch(branchid:string)
 {
  if(branchid.length==1)
  {
    this.formd.acbranch='00'+branchid;
  }
  else if(branchid.length==2)
  {
    this.formd.acbranch='0'+branchid;
  }
  else if(branchid.length==3)
  {
    this.formd.acbranch=branchid;
  } 
 }

 setsubid(subid:string)
 {
   debugger;
   if(subid.length==1)
    {
      this.formd.aglsub='00'+subid;
    }
    else if(subid.length==2)
    {
      this.formd.aglsub='0'+subid;
    }
    else if(subid.length==3)
    {
      this.formd.aglsub=subid;
    } 
 }

 getname(BRANCH_ID:number,actype:number,GLSUB_ID:number,acbranch:string,yrnd:string,ac_no:string,glsub:string) { // without type info
  debugger;
       this.accno = acbranch+yrnd+ac_no+glsub;    //event.target.value + ' | ';
      this.customeracc(BRANCH_ID,actype,GLSUB_ID,this.accno);
  
    }
   customeracc(BRANCH_ID:number,actype:number,GLSUB_ID:number,acc_no:string)
   {
   debugger;
    this.custdata=this.service.custlist(this.chckbint(BRANCH_ID),this.chckbint(actype),this.chckbint(GLSUB_ID),this.chckbstr(acc_no));
    this.custdata.subscribe(
      (cusres:any)=>{
      this.custopt=cusres;
      debugger;
      this.formd.Name=this.custopt.NAME;
      this.formd.fromdate=this.getdatefun(this.custopt.OPEN_DT);
      this.formd.todate= this.getdatefun(this.today);
      
    }
    )
   }

   getdatefun(indt:any)
   {
     this.DateValues=this.datePipe.transform(indt,'yyyy-MM-dd');
     return this.DateValues;
  }

  resetFormc(formd? : NgForm){
    swal({
    title:'Are you sure?',
    text: "You want to Cancel this!",
  type: 'warning',
  showCancelButton: true,
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
  confirmButtonText: 'Yes, Clear it!'
  }).then((result) => {
  if (result.value) {
    swal(
     'Cleared!',
     'Your file has been Cleared.',
     'success'
    )
  if(formd !=null)
 formd.reset();
 this.formd.BRANCH_ID=null;
 this.formd.actype='';
 this.formd.L_Code='';
 this.formd.GLSUB_ID='';
 this.formd.cr_dr='';
 this.formd.transmode=''; 
 this.formd.AGENT_ID=''; 
 this.formd.acbranch='';
 this.formd.ayrnd='';
 this.formd.ac_no='';
 this.formd.aglsub='';
 this.formd.Name='';
 this.formd.transmode='';
 this.formd.fromdate='';
 this.formd.todate='';

}
});
}

resetForm(form?:NgForm)
{
 if(form!=null)
 {
  this.formd.BRANCH_ID=null;
  this.formd.actype='';
  this.formd.L_Code='';
  this.formd.GLSUB_ID='';
  this.formd.cr_dr='';
  this.formd.transmode=''; 
  this.formd.AGENT_ID=''; 
  this.formd.acbranch='';
  this.formd.ayrnd='';
  this.formd.ac_no='';
  this.formd.aglsub='';
  this.formd.Name='';
  this.formd.transmode='';
  this.formd.fromdate='';
  this.formd.todate='';

 }
 }

  sheet_rpt()
  {
    this.formd.pigmysheetreport=null;
  }
  coll_rpt()
  {
    this.formd.pigmysheet=null;
  }


//for statement report
  onKeyacc(branch:any,yrnd:any,acn:any,subid:any,branch_id:number,actype:any,GLSUB_ID:any)
  {
    debugger;
  this.accno = this.checkstringnul(branch)+this.checkstringnul(yrnd)+this.checkstringnul(acn)+this.checkstringnul(subid);
  this.notaccno=this.checkstringnul(acn)+this.checkstringnul(subid);
    if(this.accno.length<16)
    {
      this.disaccdata=this.service.getallaccountuniversreport(this.notaccno,subid,branch_id);
      this.disaccdata.subscribe(
        (accres:any)=>{
          this.disacopt=accres;
          console.log(this.disacopt);
          this.openModalDialog();
        })
     
    }
     else
     {
       this.getname(branch_id,actype,GLSUB_ID,branch,yrnd,acn,subid) ;
     }
  }

  Getbynumber(accn:string,subid:number,branch:number,actype:number)
  {
    debugger;
    let acbranchnum="";
    let acyrnd="";
    let acccno="";
    let accsubid="";
    debugger;
    for(let i=0;i< this.disacopt.length;i++)
    {
      if(this.disacopt[i].ACC_NO==accn)
      { debugger;
        let accnum=this.disacopt[i].ACC_NO;
        let acnaqm=this.disacopt[i].NAME;
        this.formd.acbranch=accnum.substring(0,3);
        acbranchnum=accnum.substring(0,3);
        this.formd.ayrnd=accnum.substring(7,3);
        acyrnd=accnum.substring(7,3);
        this.formd.ac_no=accnum.substring(13,7);
        acccno=accnum.substring(13,7);
       // this.formpigmypart.glsubid=accnum.substring(16,13);
       accsubid=accnum.substring(16,13);
       debugger;
      //  console.log(accnum);
      //  console.log(" branch");
      //  console.log(accnum.substring(0,3));
      //  console.log("yr");
      //  console.log(accnum.substring(7,3));
      //  console.log("acc_no");
      //  console.log(accnum.substring(13,7));
      //  console.log("subid");
      //  console.log(accnum.substring(16,13));
      debugger;
      this.getname(branch,actype,subid,acbranchnum,acyrnd,acccno,accsubid) ;
        this.closeModalDialog();
      }
    }
  }
  
  bindingtoform(pigres: any) {
    throw new Error("Method not implemented.");
  }

  closeModalDialog(){
    this.display='none'; //set none css after close dialog
    }
  openModalDialog(){
    this.display='block'; //Set block css
  }

  checkstringnul(str:string)
  {
    if(str!=null)
    {
      return str;
    }
    else
     return "";
  }


  collreport()
  {
    this.fldopdtion1=true;
    this.fldopdtion2=true;
    this.fldopdtion3=false;
    this.fldopdtion4=false;
    this.fldopdtion5=false;
    this.fldopdtion6=false;
    this.fldopdtion7=true;
    this.fldopdtion8=false;
    this.fldopdtion9=false;
    this.fldopdtion10=false;
    this.fldopdtion11=false;
    this.fldopdtion12=false;
    this.fldopdtion13=false;
    this.fldopdtion14=true;
    this.fldopdtion15=true;
    this.formd.basicreport=null;
    this.formd.detailreport=null;
    this.formd.stmtreport=null;
    this.formd.loanrecreport=null;
    this.formd.detailreport2=null;
    this.formd.pigmysheetreport=null;
    this.formd.loanondeposit=null;
    this.formd.dailycolreport=null;
  }
  Agentwise(option,agentid)
  {
    if(agentid==undefined)
      swal('Agent','Please select agent to continue','warning');
    else if(option=="agentwise")
      window.open(this.commonUrl+'/Reports/Collectionreport/AgentwiseCollection/AgentWiseCollection.aspx?userName='+this.userName);
    else if(option=="agentcustwise")
    window.open(this.commonUrl+'/Reports/Collectionreport/AgentCustWise/AgentCustWiseReport.aspx?userName='+this.userName+'&agent='+agentid);
  }

  agentcustomerwise(agentid)
  {
    window.open(this.commonUrl+'/Reports/Collectionreport/AgentCustWise/AgentCustWiseReport.aspx?userName='+this.userName);
  }
  hidefiedl()
  {
    this.fldopdtion7=false;
  }
  showfiedl()
  {
    this.fldopdtion7=true;
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/transaction-report/transaction-report.component.ts